import vIgnore from "./v-ignore.vue";

export default Vue => {
  Vue.component("v-ignore", vIgnore);
};
